const sephoraMLSelector = store => store.sephoraML;

export { sephoraMLSelector };
